import React from 'react';
import PropTypes from 'prop-types';
import {connect} from 'react-redux';
import {FormattedMessage} from 'react-intl';
import {
  baseStyles,
  BORDER_RADIUS,
  FIELD_SPACE,
  FIELD_SPACE_XS,
  FONT_WEIGHT_BOLD,
  FORM_INNER_X_WIDE_MAX_WIDTH,
  IMAGE_BORDER_RADIUS,
  withMediaQueries,
  withMultipleStyles
} from "src/styles/Styles";
import {Typography} from "@material-ui/core";
import {
  ACTIVITY_TYPES_CAMPAIGN_MODEL,
  ACTIVITY_TYPES_CAMPAIGN_MODEL_ENTERTAINMENT,
  ACTIVITY_TYPES_CAMPAIGN_MODEL_INTERACTIVE,
  ACTIVITY_TYPES_REWARD_MODEL
} from "../admin/management/activities/ActivityLists";
import {
  ColorBackground,
  ColorBlack,
  ColorField,
  ColorFieldBorder,
  ColorFieldBorderHover,
  ColorFieldHover,
  ColorPreviewBorder,
  ColorTheme,
  ColorTitle,
  ColorWhite
} from "src/styles/Colors";
import constants from "../../constants";
import FormHelperText from "@material-ui/core/FormHelperText";
import DateTimeHelper from "../../utils/DateTimeHelper";
import {colorWithAlpha} from "../../utils/utils";
import ApiHelper from "../../utils/ApiHelper";
import {cloneDeep} from "lodash";
import TextView from "src/js/components/commons/TextView";
import {FontWeightMedium} from "src/res/FontWeight";
import TouchableOpacity from "src/js/components/commons/TouchableOpacity";
import AppIcon, {IconCheck} from "src/js/components/commons/AppIcon";
import Paper from "@material-ui/core/Paper";

const useStyles = (theme) => ({
  typeActivityCardWrapper: {
    display: 'flex',
    width: '100%',
    flexDirection: 'row',
    alignItems: 'center',
    maxWidth: FORM_INNER_X_WIDE_MAX_WIDTH,
  },
  typeActivityCard: {
    borderRadius: BORDER_RADIUS,
    overflow: 'hidden',
    margin: 4,
  },
  typeActivityView: {
    position: 'relative',
    display: 'flex',
    flex: 1,
    flexDirection: 'column',
    borderRadius: BORDER_RADIUS,
    padding: 6,
    border: '1px solid '+ ColorFieldBorder,
    backgroundColor: ColorField,
    width: 152,
    '&:hover': {
      backgroundColor: ColorFieldHover,
      border: '1px solid '+ ColorFieldBorderHover,
    },
    [theme.breakpoints.down('xs')]: {
      width: 113,
      padding: 4,
    }
  },
  typeActivityViewSelected: {
    position: 'relative',
    display: 'flex',
    flex: 1,
    flexDirection: 'column',
    borderRadius: BORDER_RADIUS,
    padding: 6,
    border: '2px solid '+ ColorTheme,
    backgroundColor: ColorWhite,
    width: 152,
    [theme.breakpoints.down('xs')]: {
      width: 113,
      padding: 4,
    }
  },
  typeActivityImage: {
    width: 140,
    height: 140/16*9,
    borderRadius: IMAGE_BORDER_RADIUS,
    padding: 0,
    border: '1px solid rgba(0,0,0,0.03)',
    [theme.breakpoints.down('xs')]: {
      width: 102,
      height: 102/16*9,
    },
  },
  typeHeader: {
    paddingLeft: 14,
    paddingRight: 14,
    paddingBottom: 2,
    backgroundColor: colorWithAlpha(ColorBlack, 0.03),
    borderTopLeftRadius: BORDER_RADIUS - 2,
    borderTopRightRadius: BORDER_RADIUS - 2,
    width: '100%'
  },
});

class ManageActivityType extends React.Component {

  constructor(props) {
    super(props);
    const {activityData, typesData} = this.props;
    this.externalGameTypes = null;
    Object.keys(typesData).forEach((typeId) => {
      const splits = typeId.split('-');
      const type = splits[0];
      if (type == constants.activity.types.EXTERNAL_GAMES) {
        const subType = splits[1];
        if (!this.externalGameTypes) {
          this.externalGameTypes = [];
        }
        this.externalGameTypes.push({'id': parseInt(type), 'subId': parseInt(subType), 'name': typesData[typeId].gameInfo.name});
      }
    });
    const activityTypes = this.getActivityTypes(activityData.usageType);

    this.state = {
      appWidth: window.appWidth,
      appHeight: window.appHeight,
      show: false,
      activityType: activityData.activityType,
      activitySubType: activityData.activitySubType,
      activityTypes: activityTypes,
      showValidationMsg: false,
    };
  }

  componentDidMount() {
    this.props.moveNextCallback(this);
    if (this.props.activityData.skipType && this.props.moveNext) {
      this.state.activityType = this.props.activityData.skipType;
      this.state.activitySubType = this.props.activityData.skipSubType;
      this.props.moveNext(this.getData(true));
    } else {
      this.setState({show: true});
    }
    window.addEventListener('resize', this.handleResize);
  }

  componentWillUnmount() {
    window.removeEventListener('resize', this.handleResize);
  }

  handleResize = () => {
    this.setState({appWidth: window.appWidth, appHeight: window.appHeight});
  };

  reset() {
    this.setState({activityType: 0, activitySubType: 0});
  }

  updateState(fields) {
    this.setState(fields, () => {
      this.props.onDataUpdated(this.getData(true));
    });
  }

  getData(excludeError) {
    const {activityType, activitySubType} = this.state;
    const {activityData} = this.props;

    if (!excludeError) {
      if (!activityType) {
        this.updateState({showValidationMsg: true});
        return false;
      }
    }

    const newActivityData = {
      usageType: activityData.usageType,
      activityType,
      activitySubType,
      imageUrl: ApiHelper.getActivityDefaultImageUrl(activityType, activitySubType, activityData.gameInfo)
    };

    let type = newActivityData.activityType;
    let isVoucher = false;
    if (type === constants.activity.types.VOUCHER) {
      type = constants.activity.types.OFFER;
      isVoucher = true;
    }
    newActivityData.type = type;
    newActivityData.subType = newActivityData.activitySubType;
    newActivityData.isVoucher = isVoucher;

    // set defaults
    newActivityData.targetingState = 0;
    newActivityData.rewardState = constants.activity.state.DELETE;
    newActivityData.isRewardStateUpdated = true;
    const startAtDefault = DateTimeHelper.getDateAfterMinutesFromNow(1);
    const endAtDefault = DateTimeHelper.getDateAfterDays(startAtDefault, 7); // 1 week
    newActivityData.startAt = startAtDefault;
    newActivityData.endAt = endAtDefault;
    // newActivityData.title = ApiHelper.getActivityDefaultTitle(activityData.business.name, activityType, this.context.intl);
    // points conditions
    newActivityData.pointsNeeded = 0;
    newActivityData.fee = 0;
    newActivityData.consumedPoints = 0;
    // right option
    if (newActivityData.type === constants.activity.types.GUESS) {
      newActivityData.rightOption = 1;
    }
    // reset days
    if (newActivityData.type === constants.activity.types.JACKPOT
      || newActivityData.type === constants.activity.types.GAME_GREEDY_SPIN
      || newActivityData.type === constants.activity.types.GAME_BETTING_PIC
      || newActivityData.type === constants.activity.types.GAME_ROULETTE
      || newActivityData.type === constants.activity.types.GAME_SPIN_N_DISCOVER
      || newActivityData.type === constants.activity.types.GAME_FLIP_CARD
      || newActivityData.type === constants.activity.types.GAME_FIND_HIDDEN
      || newActivityData.type === constants.activity.types.GAME_MATCH_PAIR
      || newActivityData.type === constants.activity.types.GAME_TIC_TAC_TOE
      || newActivityData.type === constants.activity.types.GAME_POKER
      || newActivityData.type === constants.activity.types.GAME_MATCH_THREE
      || newActivityData.type === constants.activity.types.GAME_PUZZLE
      || newActivityData.type === constants.activity.types.GAME_PUZZLE_SLIDE
      || newActivityData.type === constants.activity.types.GAME_WHAC_A_MOLE
      || newActivityData.type === constants.activity.types.GAME_BRAND_RACE
      || newActivityData.type === constants.activity.types.EXTERNAL_GAMES) {
      newActivityData.consumeLimitPerDay = 0;
      newActivityData.resetLimitPerUser = 0;
    }
    // consumables
    if (newActivityData.type === constants.activity.types.OFFER) {
      newActivityData.consumableAt = 1;
      if (newActivityData.isVoucher) {
        newActivityData.consumableAt = 10;
      }
    }

    return newActivityData;
  }

  render() {
    const {appWidth, appHeight, show, showValidationMsg, activityType, activitySubType, activityTypes} = this.state;
    const {app, classes, isShowingRewards, isXS} = this.props;
    if (!show) {
      return null;
    }

    let activityTypeError = null;
    if (showValidationMsg) {
      if (!activityType) {
        activityTypeError = this.context.intl.formatMessage({id: isShowingRewards ? 'campaign.selectRewardType' : 'campaign.selectType'});
      }
    }

    const space = isXS ? 8 : 12;
    let width = 142;
    if (isXS) {
      const viewWidth = appWidth-32;
      width = viewWidth/3;
      if (viewWidth < 220) {
        width = viewWidth;
      } else if (viewWidth < 330) {
        width = viewWidth/2;
      }
    }
    return (
      <div style={{marginBottom: isXS ? 4 : 0, marginTop: isXS ? -4 : 0}}>
        {activityTypeError && <FormHelperText className={classes.helperError} style={{marginBottom: 8}}>{activityTypeError}</FormHelperText>}
        {activityTypes.map((item, index) => {
          return (
            <div className={classes.viewColumnFullWidthNoCenter} style={{marginTop: index === 0 ? 0 : (isXS ? FIELD_SPACE_XS : FIELD_SPACE)}}>
              {item.nameId ?
                <div className={classes.flexRow} style={{justifyContent: 'flex-start', backgroundColor: ColorPreviewBorder, borderRadius: 16, marginBottom: 12, padding: 16, paddingTop: 6, paddingBottom: 6}}>
                  <TextView variant={'body1'} color={ColorTitle} align={'left'} fontWeight={FONT_WEIGHT_BOLD} >
                    <FormattedMessage id={item.nameId} />
                  </TextView>
                </div>
                : null
              }
              <Typography style={{height: 1, opacity: 0}}>{"Added dummy view to stretch the parent to fill the width completely. Some more strings ad"}</Typography>
              <div className={classes.viewFullWidthWrap} style={{}}>
                {item.items.map((item, index) => {
                  const isSelected = item.id === activityType && item.subId === activitySubType;
                  const imageUrl = ApiHelper.getActivityDefaultImageUrl(item.id, item.subId, item.gameInfo);
                  return (
                    <div key={index} className={classes.viewColumnFullWidth} style={{width: width, paddingLeft: space, paddingRight: space, position: 'relative'}}>
                      <TouchableOpacity onClick={this.onItemClick.bind(this, item)} className={classes.viewColumnFullWidth} style={{maxWidth: width-space*2, borderRadius: 16, position: 'relative'}}>
                        <div className={classes.viewColumnFullWidth} style={{maxWidth: width-space*2, borderRadius: 16}}>
                          <img src={imageUrl} style={{width: width-space*2, height: (width-space*2)/4*3, borderRadius: 16, backgroundColor: ColorBackground}} />
                          <div className={classes.flexRow} style={{minHeight: isXS ? 50 : 60, alignItems: 'flex-start', justifyContent: 'center'}}>
                            <TextView numberOfLines={2} align={'center'} text={item.name} color={ColorTitle} variant={isXS ? 'body2' : 'body1'} fontWeight={FontWeightMedium} style={{marginTop: 4, paddingLeft: 8, paddingRight: 8, wordBreak: 'break-all'}} />
                          </div>
                        </div>
                        {isSelected ?
                          <div className={classes.viewColumn} style={{position: 'absolute', top: 0, left: 0, bottom: 10, right: 0, borderRadius: 16, backgroundColor: colorWithAlpha(ColorTheme, 0.2), padding: 4, pointerEvents: 'none'}}>
                            <Paper className={classes.viewColumn} style={{position: 'absolute', top: 4, left: 4, width: 22, height: 22, borderRadius: 11, backgroundColor: ColorWhite, padding: 2, pointerEvents: 'none'}}>
                              <div className={classes.flexColumn} style={{backgroundColor: ColorTheme, borderRadius: 9, justifyContent: 'center'}}>
                                <AppIcon icon={IconCheck} color={ColorWhite} style={{width: 12, height: 12}}/>
                              </div>
                            </Paper>
                          </div>
                          : null
                        }
                      </TouchableOpacity>
                    </div>
                  );
                })}
              </div>
            </div>
          );
        })}
      </div>
    )
  }

  onItemClick = (item) => {
    this.setState({activityType: item.id, activitySubType: item.subId, showValidationMsg: false}, () => {
      if (this.props.moveNext) {
        this.props.moveNext(this.getData(true));
      }
    });
  }

  getActivityTypes(usageType) {
    if (this.props.isShowingRewards) {
      return [
        {'nameId': null, items: ACTIVITY_TYPES_REWARD_MODEL},
      ];
    }

    let preferredTypeIds = null;
    if (usageType) {
      // preferredTypeIds = [1, 11, 15, 31, 32];
    }
    let preferredTypes = null;
    if (preferredTypeIds) {
      preferredTypes = [];
      ACTIVITY_TYPES_CAMPAIGN_MODEL.forEach((item) => {
        if (preferredTypeIds.includes(item.id)) {
          preferredTypes.push(item);
        }
      });
    }

    const items = [];
    if (ACTIVITY_TYPES_CAMPAIGN_MODEL_ENTERTAINMENT && ACTIVITY_TYPES_CAMPAIGN_MODEL_ENTERTAINMENT.length > 0) {
      let activityTypes = cloneDeep(ACTIVITY_TYPES_CAMPAIGN_MODEL_ENTERTAINMENT);
      if (this.externalGameTypes && this.externalGameTypes.length > 0) {
        activityTypes = cloneDeep(activityTypes);
        this.externalGameTypes.forEach((externalGameType) => {
          activityTypes.push(externalGameType);
        });
      }
      items.push({'nameId': 'campaign.manage.gamesFun', items: activityTypes});
    }
    if (ACTIVITY_TYPES_CAMPAIGN_MODEL_INTERACTIVE && ACTIVITY_TYPES_CAMPAIGN_MODEL_INTERACTIVE.length > 0) {
      items.push({'nameId': 'campaign.manage.interactiveFun', items: ACTIVITY_TYPES_CAMPAIGN_MODEL_INTERACTIVE});
    }

    if (preferredTypes && preferredTypes.length > 0) {
      items.splice(0, 0, {'nameId': 'campaign.manage.recommendedFun', items: preferredTypes});
    }
    return items;
  }

}

ManageActivityType.propTypes = {
  classes: PropTypes.object,
  disabled: PropTypes.bool,
  activities: PropTypes.object,
  activityData: PropTypes.object,
  categories: PropTypes.array,
  moveNextCallback: PropTypes.func.isRequired,
  onDataUpdated: PropTypes.func.isRequired,
  fetchBusinesses: PropTypes.func,
};

ManageActivityType.contextTypes = {
  intl:PropTypes.object.isRequired
}

function mapStateToProps(state) {
  return {
    app: state.app,
    user: state.admin.user,
    activities: state.admin.activities,
  };
}

const mapDispatchToProps = (dispatch) => {
  return {
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(withMultipleStyles(baseStyles, useStyles)(withMediaQueries([
  ['isXS', theme => theme.breakpoints.down('xs'), {
    defaultMatches: true
  }]
])(ManageActivityType)));
